import { useQuery } from "@tanstack/react-query";
import { WorkspaceConfig } from "types/WorkspaceConfig";
import { axiosBeyonClient } from "utils/beyonAuth/beyonAxiosClient";

type useTagsProps = {
    workspaceId: string;
    workspaceConfig: WorkspaceConfig,
    enabled: boolean;
};

export function useTags({ workspaceId, workspaceConfig, enabled }: useTagsProps) {

    const apiEndpoint = workspaceConfig?.connectorConfig?.apiEndpoint;
    const apiIndexRoute = workspaceConfig?.tagConfig?.apiIndexRoute;

    return useQuery({
        queryKey: ['tags', workspaceId],
        enabled,
        queryFn: async () => {
            if (!apiIndexRoute || !apiEndpoint)
                throw new Error("Invalid tag configuration");

            const url = `${apiEndpoint}/${apiIndexRoute}`;

            const result = await axiosBeyonClient.get<string[]>(url);
            return result.data;
        }
    });
}
